<template>
  <div>
    <div v-for="(rec, index) in rackInfoList" :key="index">
      <v-row no-gutters class="py-1">
        <v-col cols="4" class="pr-2">
          <NormalNumberInput v-model="rackInfoList[index].quantity" />
        </v-col>
        <v-col cols="6">
          <v-combobox
            v-model="rackInfoList[index].rackNumber"
            height="32px"
            outlined
            dense
            hide-details
            :items="rackNumberList"
            :append-icon="null"
          ></v-combobox>
        </v-col>
        <v-col cols="2">
          <v-btn icon class="pb-1" @click="onClick(index)">
            <v-icon>{{ 'mdi-plus-circle-outline' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import NormalNumberInput from '@/components/items/inputs/NormalNumberInput'

export default {
  components: {
    NormalNumberInput
  },
  data: () => ({
    rackInfoList: [
      {
        quantity: '',
        rackNumber: ''
      }
    ]
  }),
  props: {
    rackNumberList: {
      type: Array,
      require: true,
      default: () => []
    },
    defaultQuantity: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.rackInfoList[0].quantity = this.defaultQuantity
  },
  methods: {
    onClick(idx) {
      this.rackInfoList.splice(idx + 1, 0, {
        quantity: 0,
        rackNumber: ''
      })
    }
  },
  watch: {
    rackInfoList: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    },
    defaultQuantity: function (newVal, oldVal) {
      this.rackInfoList[0].quantity = newVal
    }
  }
}
</script>
<style scoped lang="scss"></style>
